import ActionNode from './ActionNode'

class ActionNodeEmail extends ActionNode {
  constructor(model) {
    super(model)
    this.text = model.value.text
    this.icon = {
      ...this.icon,
      name: 'email'
    }
  }

  changeValue(value) {
    this.value = value
    this.text = value.text
  }
}

export default ActionNodeEmail



// WEBPACK FOOTER //
// ./src/utils/models/node/ActionNodeEmail.js